import { Stack, Text } from '@fluentui/react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { FeedbackOverTimeResponse } from '../../api/models'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

type FeedbackOverTimeChartProps = {
  data: FeedbackOverTimeResponse | null
}

const cardStyle = {
  root: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    flex: 1,
  },
}

const FeedbackOverTimeChart = ({ data }: FeedbackOverTimeChartProps) => {
  if (!data) return null

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Positive',
        data: data.positive,
        backgroundColor: '#5B8A72',
        borderRadius: 3,
      },
      {
        label: 'Negative',
        data: data.negative,
        backgroundColor: '#D4775B',
        borderRadius: 3,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  }

  return (
    <Stack styles={cardStyle} tokens={{ childrenGap: 12 }}>
      <Text variant="mediumPlus" styles={{ root: { fontWeight: 600, color: '#605e5c' } }}>
        Weekly Feedback: Positive vs Negative
      </Text>
      {data.labels.length > 0 ? (
        <div style={{ height: 300 }}>
          <Bar data={chartData} options={options} />
        </div>
      ) : (
        <Text styles={{ root: { color: '#a19f9d', textAlign: 'center', padding: 40 } }}>
          No feedback data available for this period.
        </Text>
      )}
    </Stack>
  )
}

export default FeedbackOverTimeChart
